import { withAccessibility, type WithAccessibilityProps } from '@cheqroom/ui';
import { HTMLAttributes } from 'react';
import tw, { styled } from 'twin.macro';

const StyledListItemSC = styled.li`
	${tw`py-3 px-4 border rounded-md border-gray-200 cursor-pointer`}
`;

export const StyledListItem = withAccessibility<WithAccessibilityProps & HTMLAttributes<HTMLLIElement>>(
	StyledListItemSC
);
